// extracted by mini-css-extract-plugin
export default {"button":"blueButton_button__NByeL","buttonBlue":"blueButton_buttonBlue__2eiJR"};